/**
 * @module app.core
 */

import { autoinject, bindingMode } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { LookupService as CDLookupService } from 'app/cd/services/lookup-service';
import { apiCall } from 'app/shared/lib/api/api';
import { LookupService as CoreLookupService } from 'app/core/services/lookup-service';
import { validateSSN } from 'app/shared/lib/validation/validation-utilities';
import { IQueryLoadOptions } from 'app/shared/lib/api/api-types';
import * as CD from 'app/cd/models/essette-api';
import * as Core from 'app/core/models/essette-api';

@autoinject()
export class EditMemberInformation extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    @bindable.object({ defaultBindingMode: bindingMode.twoWay })
    protected member: CD.Member = {};

    protected editMemberExternalId: boolean = false;
    protected countries: ReadonlyArray<CD.Member> = [];
    protected genders: Core.Gender[] = [];
    protected maritalStatuses: CD.MaritalStatus[] = [];
    protected languages: Core.Language[] = [];
    protected races: CD.Race[] = [];
    protected ethnicities: CD.Ethnicity[] = [];
    protected validateSSN = validateSSN;

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly coreLookupService: CoreLookupService,
        private readonly cdLookupService: CDLookupService,
        ...rest: any[]) {
        super(...rest);
    }

    protected bind(): void {
        this.loadLookups();
    }

    ////****************** Service Calls ********************************************////
    @apiCall
    private async loadLookups(): Promise<void> {
        try {
            this.state.beginLoad();

            const options: Partial<IQueryLoadOptions> = {
                all: true
            };

            const fields = ['code', 'description'];

            const [gendersResponse, maritalStatusesResponse, languagesResponse, racesResponse, ethnicitiesResponse] = await Promise.all([
                this.coreLookupService.loadGenders(options, undefined, undefined, true, fields),
                this.cdLookupService.loadMaritalStatuses(options, [], fields),
                this.coreLookupService.loadLanguages(options, undefined, fields),
                this.cdLookupService.loadRaces(options, undefined, undefined, true, fields),
                this.cdLookupService.loadEthnicities(options, undefined, fields)
            ]);

            this.genders = gendersResponse.results;
            this.maritalStatuses = maritalStatusesResponse.results;
            this.languages = languagesResponse.results;
            this.races = racesResponse.results;
            this.ethnicities = ethnicitiesResponse.results;
        } catch(error) {
            throw error;
        } finally {
            this.state.endLoad();
        }
    }
}
